import { Box, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { CardContainerRetro } from "../Container/CardContainerRetro";
import { NavLink } from "react-router-dom";
import { WriterInfo } from "../WriterInfo/WriterInfo";
import MetricStatus from "../MetricStatus/MetricStatus";

export const CardMyCollection = ({
  collection,
  date,
  rd = 8,
  borderType = "full",
  isMobile,
  isMe = false,
}) => {
  const theme = useTheme();

  return (
    <NavLink
      to={
        isMe
        
          ? `/my-collection/${collection.id}`
          : `/collection/${collection.id}`
      }
      style={{ width: "100%" }}
    >
      <CardContainerRetro w={"100%"} rd={rd} borderType={borderType}>
        <Stack
          spacing={6}
          justifyContent="space-between"
          sx={{
            padding: isMobile ? theme.spacing(2) : theme.spacing(3),
            width: "100%",
            height: isMobile ? "180px" : "auto",
            backgroundColor: theme.palette.background.paper,
            borderRadius: theme.spacing(0.5),
          }}
        >
          <Stack spacing={0.5}>
            <Typography
              variant={isMobile ? "h6" : "h5"}
              sx={{
                fontFamily: '"source-han-serif-korean", "Noto Serif KR", "Noto Serif CJK KR", "Source Han Serif KR", "Apple SD Gothic Neo", "Malgun Gothic", "맑은 고딕", serif',
                lineHeight: 1.55,
                height: isMobile ? 44 : 52,
                fontWeight: 900,
                width: isMobile ? "100%" : "calc(100% - 16px)",
                color: theme.palette.text.primary,
                overflow: "hidden",
              }}
            >
              {collection.title}
            </Typography>
            {!isMobile && (
              <Typography
                sx={{
                  lineHeight: 1.55,
                  fontSize: isMobile ? "0.875rem" : "1rem",
                  color: theme.palette.text.primary,
                  height: isMobile
                    ? `${0.875 * 1.55 * 3}rem`
                    : `${1 * 1.55 * 3}rem`,
                  fontWeight: 600,
                  width: isMobile ? "100%" : "calc(100% - 16px)",
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: "vertical",
                }}
              >
                {collection.description}
              </Typography>
            )}
          </Stack>
          <WriterInfo
            size={isMobile ? "small" : "default"}
            profileImage={collection.profileImage}  // 기존 필드 유지
            userID={collection.userID}              // 🆕 신규 필드 추가
            username={collection.username}
            name={collection.name}
          />
          {!isMobile && (
            <Stack
              direction="row"
              spacing={isMobile ? 1 : 2}
              sx={{
                color: theme.palette.text.secondary,
                flexWrap: "wrap",
              }}
            >
              <MetricStatus
                w={"auto"}
                isMobile={isMobile}
                type={"view"}
                value={collection.metric?.views}
                size={isMobile ? 16 : 24}
              />
              <MetricStatus
                w={"auto"}
                isMobile={isMobile}
                type={"like"}
                value={collection.metric?.likes}
                size={isMobile ? 16 : 24}
              />
              <MetricStatus
                w={"auto"}
                isMobile={isMobile}
                type={"reply"}
                value={collection.metric?.replies}
                size={isMobile ? 16 : 24}
              />
              <MetricStatus
                w={"auto"}
                isMobile={isMobile}
                type={"repost"}
                value={collection.metric?.reposts}
                size={isMobile ? 16 : 24}
              />
            </Stack>
          )}
        </Stack>
      </CardContainerRetro>
    </NavLink>
  );
};
